import React, { Suspense, lazy } from "react";
import Banner from "../../components/Banner/Banner";
import WelcomeBanner from "../../components/Banner/WelcomeBanner";
import { ShimmerUI } from "../../components/ShimmerUI/ShimmerUI";
import useFetch from "../../hooks/useFetch";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";

// Lazy load components
const NewArrivals = lazy(() => import("../../components/home/NewArrivals/NewArrivals"));
const CategoryProducts = lazy(() => import("../../components/home/CategoryProducts/CategoryProducts"));
const Categories = lazy(() => import("../../components/home/Categories/Categories"));
const AllProducts = lazy(() => import("../../components/home/AllProducts/AllProducts"));
const SpecialOffers = lazy(() => import("../../components/home/SpecialOffers/SpecialOffers"));

const Home = () => {
  const { data, loading, error } = useFetch(`/app/home`);

  if (loading) return <ShimmerUI />;
  if (error) return <div className="text-center text-red-500 p-4">Error loading content</div>;
  if (!data?.payload) return <ShimmerUI />;

  const { latest_added_list, list, offer_list, categoryList, categories } = data.payload;

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8 py-8">
          <Banner />
          <WelcomeBanner />

          <Suspense fallback={<ShimmerUI />}>
            {categoryList?.length > 0 && (
              <div className="transition-all duration-300 ease-in-out">
                <Categories categoryList={categoryList} />
              </div>
            )}

            {latest_added_list?.length > 0 && (
              <div className="transition-all duration-300 ease-in-out">
                <NewArrivals latest_added_list={latest_added_list} />
              </div>
            )}

            {offer_list?.length > 0 && (
              <div className="transition-all duration-300 ease-in-out">
                <SpecialOffers offer_list={offer_list} />
              </div>
            )}

            {categories?.length > 0 && (
              <div className="space-y-12">
                {categories.map((item, index) => (
                  item?.products?.length > 0 && (
                    <div key={index} className="transition-all duration-300 ease-in-out">
                      <CategoryProducts offer_list={item} />
                    </div>
                  )
                ))}
              </div>
            )}

            {list?.length > 0 && (
              <div className="transition-all duration-300 ease-in-out">
                <AllProducts list={list} />
              </div>
            )}
          </Suspense>
        </div>
        <ScrollToTop />
      </div>
    </ErrorBoundary>
  );
};

export default Home;
